module.exports = __webpack_public_path__ + "static/media/kanlin.484890c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kanlin.mp4
// module id = GeMU
// module chunks = 2